import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel2, HeadingLevel1 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const CardHeaderStyled = styled.div `
  margin-bottom: 24px;

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: 32px;
  }
`;
export const SubtitleStyled = styled(HeadingLevel2) `
  ${getTextStyles('Play', 700, 14, 16)}

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles('Play', 700, 18, 24)}
  }
`;
export const TitleStyled = styled(HeadingLevel1) `
  ${getTextStyles('Play', 700, 24, 28)}

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles('Play', 700, 32, 40)}
  }
`;
